import { Box, Container, ResponsiveValue } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'

import CuideiFooter from './CuideiFooter'
import CuideiHeader from './CuideiHeader'

interface CuideiShellProps {
  children: ReactNode
  /** Constrain the inner content width. Flow steps stay narrow; the landing goes wide. */
  maxW?: string
  /** Optional right-aligned header action (e.g. the landing "Começar agora" CTA). */
  headerAction?: ReactNode
  /** Space kept free under the footer (e.g. for a fixed bottom bar). */
  bottomInset?: ResponsiveValue<string | number>
  /** A landing's Google Ads clone: the footer drops the prescription wording. */
  variant?: 'seo' | 'gads'
}

/**
 * Shared Cuidei chrome: header + light blue-gray page background + footer.
 * Wraps both the landing (wide) and the patient flow (narrow column).
 */
const CuideiShell: FC<CuideiShellProps> = ({ children, maxW = 'container.sm', headerAction, bottomInset, variant }) => (
  // Full-bleed bands (100vw) count the scrollbar: clip them so the page never scrolls sideways.
  <Box minH="100vh" bg="cuidei.10" display="flex" flexDir="column" pb={bottomInset} overflowX="clip">
    <CuideiHeader maxW={maxW} action={headerAction} />
    <Box flex="1">
      <Container maxW={maxW} py={{ base: 6, md: 10 }}>
        {children}
      </Container>
    </Box>
    <CuideiFooter maxW={maxW} variant={variant} />
  </Box>
)

export default CuideiShell
